import { render } from "./GlobalBannerAlert.vue?vue&type=template&id=47328d9e&scoped=true"
import script from "./GlobalBannerAlert.vue?vue&type=script&lang=js"
export * from "./GlobalBannerAlert.vue?vue&type=script&lang=js"

import "./GlobalBannerAlert.vue?vue&type=style&index=0&id=47328d9e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47328d9e"]])

export default __exports__